import { PagedResults } from "../models/generics";
import { Sport } from "../types/Sport";
import { UserDTO } from "../types/User";
import client from "./axios";

const sportUrl = `https://internal-api.getmoveapp.com/api/v1/sports`;
const rankingsUrl = `https://internal-api.getmoveapp.com/api/v1/rankings`;

export const Sports = {
  getSports: (query: { name?: string }) =>
    client.get<{ list: Sport[] }>(`${sportUrl}`, { params: query }),
  getRankings: (query: { structureId?: string, page?: number, limit?: number }) =>
    client.get<PagedResults<UserDTO> | { rankings: UserDTO }>(
      `${rankingsUrl}`,
      {
        params: query,
      }
    ),
};
